<template>
  <h2 class="text-[24px] text-[#004466] font-[600]">{{ title }}</h2>
</template>
<script setup>
const props = defineProps(["title"]);
</script>
